export const css = {
    root: '_3jFDb2z8',
    content: '_33eKYQsO',
    title: '_2x9Z_fwV',
    subtitle: 'vD9i5vPD',
    actions: '_2TyfX8Lv',
    ' _key': 'certificate/cert-card'
};
export default css;
